module.exports = __webpack_public_path__ + "static/media/eyebrow-logo.0a80d3b4.png";